const errorCheck = (
  errors,
  touched,
  value = ""
) => {
  return Boolean(errors[value] && touched[value]) && errors[value]
}

export default errorCheck